module.exports = __webpack_public_path__ + "static/BentonSans-Regular.d8f5bb16.otf";


//////////////////
// WEBPACK FOOTER
// ./src/css/BentonSans-Regular.otf
// module id = ./src/css/BentonSans-Regular.otf
// module chunks = 17241999800008180000